@if (!overriddenHeaderName) {
    @for (option of group.options; track option; let first = $first) {
        <div class="grid-group-header" [class.grid-group-attribute]="first && group.marketAttribute">
            {{ option }}
        </div>
    }
}
@if (overriddenHeaderName) {
    <div class="grid-group-header">
        {{ overriddenHeaderName }}
    </div>
}
